import requestAction from '../../utils/requestAction'

export const fetchGoal = (goalId: string) =>
  requestAction('GOAL_DETAIL')(`goals/${goalId}`, 'GET')
